// extracted by mini-css-extract-plugin
export default {"loginScreen":"Login_loginScreen__3N-fJ","loginBox":"Login_loginBox__ENnYn","closeIcon":"Login_closeIcon__RBQcY","createAcc":"Login_createAcc__h8GxT"};